import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin/admin.service';


import { EditorModule } from '@tinymce/tinymce-angular';
import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import slugify from 'slugify';
import { PagesService } from 'src/app/services/pages/pages.service';
import { FileManagerComponent } from "src/app/components/layout/file-manager/file-manager.component";
import { CatalogsService } from 'src/app/services/catalogs/catalogs.service';
import { MetaFormModalComponent } from "src/app/components/layout/meta-form-modal/meta-form-modal.component";
import { GallerySelectorComponent } from "src/app/components/layout/gallery-selector/gallery-selector.component";
import { environment } from "../../../../../environments/environment";


@Component({
  selector: 'app-catalog-form-modal',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    FileManagerComponent,
    MetaFormModalComponent,
    GallerySelectorComponent
],
  templateUrl: './catalog-form-modal.component.html',
  styleUrl: './catalog-form-modal.component.css'
})
export class CatalogFormModalComponent {

  @Input() initialData: any = null;
  @Input() menuid: number = 0
  @Output() save = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();

  form: FormGroup;
  selectedImage: string | null = null;
  gallery: string[] = [];
  loadSave = false;
  editingId: number | null = null;

  @ViewChild('fileManagerModal') fileManagerModal!: TemplateRef<any>;
  private filePickerCallback: ((url: string) => void) | null = null;
  modalRef: any;

  currentLang = 'ge'; 
  originalSlug: string = '';

  categories: any
  municipality: any

  @ViewChild('metaFormModal') metaFormModal!: TemplateRef<any>;


  paronamaGalleryImages: string[] = [];

  domain = environment.apiDomain

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ToastrService: ToastrService,
    private PagesService: PagesService,
    private AdminService: AdminService,
    private CatalogsService: CatalogsService
  ) {
    this.form = this.fb.group({
      id: [null],
      idx: [null],
      title: ['', Validators.required],
      menuid: [0],
      description: [''],
      slug: ['', Validators.required],
      image1: [''],
      image2: [''],
      image3: [''],
      image4: [''],
      image5: [''],
      image6: [''],
      postdate: [''],
      youtube: [''],
      meta_desc: [''],
      meta_keys: [''],
      visibility: [1],
      category: [null],
      x: [''],
      y: [''],
      gg_categories: [''],
      gg_municipality: [''],
      author: null,
      gallery: this.fb.control([]),
      gallery_360: [[]],
    });
  }

    ngOnInit(): void {
      this.form.get('title')?.valueChanges
        .pipe(
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe((title: string) => {
          if (title && !this.editingId) {
            const slug = slugify(title, { lower: true, strict: true });
            this.form.get('slug')?.setValue(slug, { emitEvent: false });
  
            this.checkSlugAvailability(slug);
          }
        });
  
      this.form.get('slug')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(slug => this.checkSlugAvailability(slug));
      
      this.getCategories()
      this.getMunicipality()
      
    }
  
    private checkSlugAvailability(slug: string): void {
      // თუ არ შეცვლილა, გაასუფთავე შეცდომა და დაბრუნდი
      if (slug === this.originalSlug) {
        this.form.get('slug')?.setErrors(null);
        return;
      }
  
      this.PagesService.checkSlug(slug, 'catalogs').subscribe({
        next: (res: any) => {
          if (!res.available) {
            this.form.get('slug')?.setErrors({ slugTaken: true });
          } else {
            this.form.get('slug')?.setErrors(null);
          }
        },
        error: () => {
          this.ToastrService.error('შეცდომა slug-ის შემოწმებისას');
        }
      });
    }
  
    getCategories(){
      this.CatalogsService.getCategories().subscribe(
        (res: any) => {
          console.log('cat: ', res)
          this.categories = res
        },
        (error: any) => {
          console.log(error)
        }
      )
    }

    getMunicipality(){
      this.CatalogsService.getMunicipality().subscribe(
        (res: any) => {
          console.log('mun: ', res)
          this.municipality = res
        },
        (error: any) => {
          console.log(error)
        }
      )
    }

  ngOnChanges(): void {
    if (this.initialData) {
      console.log(1, this.initialData)
      this.form.patchValue({
        id: this.initialData.id ?? null,
        idx: this.initialData.idx ?? null,
        title: this.initialData.title ?? '',
        menuid: this.initialData.menuid ?? 0,
        description: this.addDomainToImageSrc(this.decodeHtml(this.initialData.description || '')),
        slug: this.initialData.slug ?? '',
        image1: this.initialData.image1 ?? '',
        image2: this.initialData.image2 ?? '',
        image3: this.initialData.image3 ?? '',
        image4: this.initialData.image4 ?? '',
        image5: this.initialData.image5 ?? '',
        image6: this.initialData.image6 ?? '',
        postdate: this.initialData.postdate ?? '',
        youtube: this.initialData.youtube ?? '',
        meta_desc: this.initialData.meta_desc ?? '',
        meta_keys: this.initialData.meta_keys ?? '',
        visibility: this.initialData.visibility ?? 1,
        x: this.initialData.x ?? '',
        y: this.initialData.y ?? '',
        gg_categories: this.initialData.gg_categories ?? '',
        gg_municipality: this.initialData.gg_municipality ?? '',
        
        gallery: this.initialData.gallery ?? [],
        author: this.initialData.author ?? null,
        
      });
      this.originalSlug = this.initialData.slug ?? '';

      this.selectedImage = this.initialData.image || null;
      this.gallery = this.initialData.gallery || [];

      this.editingId = this.initialData.id ?? null;
      
       

      if (this.initialData) {
        const gallery360Urls = this.initialData.gallery_360
          ? this.initialData.gallery_360.map((obj: any) => obj.image)
          : [];

        this.form.patchValue({
          ...this.initialData,
          gallery_360: gallery360Urls.length ? gallery360Urls : [],
        });
      }
      // ✅ აქ ვამატებთ გამოძახებას
      // if (this.initialData.id) {
      //   this.getGallery(this.initialData.id);
      // }

    }
    if (!this.initialData && this.menuid) {
      this.form.get('menuid')?.setValue(this.menuid);
    }
  }


  openFileManagerWrapper = (callback: (url: string) => void) => {
    this.filePickerCallback = callback;
    this.modalRef = this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    });
  };

  onFileSelectedFromManager(url: string, modal: any) {
    if (this.filePickerCallback) {
      this.filePickerCallback(url);
      this.filePickerCallback = null;
    } else {
      this.form.patchValue({ image1: url });
    }
    modal.close();
  }

  openFileManagerForImage(number: number) {
    this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    });

    this.filePickerCallback = (url: string) => {
      const controlName = 'image' + number; // მაგ: image1, image2, image3
      this.form.patchValue({ [controlName]: url });
    };
  }


  onImageSelect(imageUrl: string) {
    this.selectedImage = imageUrl;
  }

  addToGallery(imageUrl: string) {
    if (!this.gallery.includes(imageUrl)) {
      this.gallery.push(imageUrl);
    }
  }


  addDomainToImageSrc(content: string): string {
    const domain = 'https://ajaraheritage.ge';
    return content.replace(
      /<img([^>]+)src="(?!https?:\/\/|data:)([^"]+)"/g,
      (match, p1, p2) => {
        const fullSrc = p2.startsWith('/') ? `${domain}${p2}` : `${domain}/${p2}`;
        return `<img${p1}src="${fullSrc}"`;
      }
    );
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  removeDomainFromImageSrc(content: string): string {
    return content.replace(/<img([^>]+)src="https?:\/\/[^\/]+(\/[^"]+)"/g, `<img$1src="$2"`);
  }

  openMetaFormModal() {
    const modalRef = this.modalService.open(MetaFormModalComponent, {
      size: 'md'
    });

    modalRef.componentInstance.meta_desc = this.form.get('meta_desc')?.value || '';
    modalRef.componentInstance.meta_keys = this.form.get('meta_keys')?.value || '';

    modalRef.componentInstance.save.subscribe((data: any) => {
      this.form.patchValue({
        meta_desc: data.meta_desc,
        meta_keys: data.meta_keys
      });
      modalRef.close();
    });
}

  saveCatalogs(){
    
    const payload = {
      ...this.form.value,
      language: this.currentLang
    };

    this.loadSave = true;

    const finalize = () => {
      this.save.emit();
      if (this.modalRef) {
        this.modalRef.close();
      }
      this.loadSave = false;
    };

    if (!this.editingId) {
      this.CatalogsService.create(payload).subscribe({
        next: () => {
          this.ToastrService.success('კატალოგი დაემატა წარმატებით');
          finalize();
        },
        error: () => {
          this.ToastrService.error('შეცდომა დამატებისას');
          this.loadSave = false;
        }
      });
    } else {
      this.CatalogsService.update(payload).subscribe({
        next: () => {
          this.ToastrService.success('კატალოგი წარმატებით განახლდა');
          finalize();
        },
        error: () => {
          this.ToastrService.error('შეცდომა შენახვისას');
          this.loadSave = false;
        }
      });
    }
  }



  onParonamaGalleryImagesSelected(images: string[]) {
    const oldImages = this.form.get('gallery_360')?.value || [];

    const combinedImages = [...oldImages];

    images.forEach(img => {
      if (!combinedImages.includes(img)) {
        combinedImages.push(img);
      }
    });

    this.paronamaGalleryImages = combinedImages;

    this.form.patchValue({
      gallery_360: combinedImages
    });

    console.log('Updated gallery_360:', combinedImages);
  }

  removeGalleryImage(index: number) {
    this.paronamaGalleryImages.splice(index, 1);
  }


   getFullImageUrl(imagePath: string): string {
      if (!imagePath) return '';

      // დროებით არ ცვლის დომენს, უბრალოდ თუ სრული URL არის, 그대로 დააბრუნე
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      // თუ რელატიური ბმულია, დროებით დაუმატე არსებული დომენი (მაგ. აჯარა)
      return `${this.domain}${imagePath.replace(/^\/+/, '')}`;
    }



}
